import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Type
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import {
  WidgetComponent,
  WidgetConfiguration,
  WidgetConfigurationType,
} from '../../models/widget-configuration.model';
import { WidgetRegistry } from '../../widget-registry.service';

@Component({
  selector: 'carehub-widget-card',
  standalone: true,
  imports: [ButtonModule, CardModule, CommonModule, ProgressSpinnerModule],
  templateUrl: './widget-card.component.html',
  styleUrl: './widget-card.component.scss',
})
export class WidgetCardComponent implements OnInit {
  @Input() widget: WidgetConfiguration | undefined;
  @Input() isEditing: boolean = false;

  @Output() widgetChange = new EventEmitter<WidgetConfiguration>();
  @Output() widgetDelete = new EventEmitter<WidgetConfiguration>();
  @Output() loadingStateChange = new EventEmitter<boolean>();

  configurationChange: EventEmitter<WidgetConfigurationType> =
    new EventEmitter<WidgetConfigurationType>();

  configurationDelete: EventEmitter<WidgetConfigurationType> =
    new EventEmitter<WidgetConfigurationType>();

  component: Type<WidgetComponent> | undefined;
  isEditingConfiguration: boolean = false;
  isLoading: boolean = false;

  constructor(private widgetRegistry: WidgetRegistry) {}

  ngOnInit(): void {
    this.component = this.widgetRegistry.getComponent(this.widget!.type);

    this.configurationChange.subscribe((configuration) => {
      this.widget!.configuration = configuration as WidgetConfigurationType;
      this.widgetChange.emit(this.widget!);
    });

    this.configurationDelete.subscribe(() => {
      this.widgetDelete.emit(this.widget!);
    });

    this.loadingStateChange.subscribe((loadingState: boolean) => {
      this.isLoading = loadingState;
    });
  }
}
